import {
  HomePageSettingsModulesModuleCalendarEventsAvailable,
  HomePageSettingsModulesModuleCalendarEventsSelected,
  HomePageSettingsModulesModuleCoursesAvailable,
  HomePageSettingsModulesModuleCoursesCategory,
  HomePageSettingsModulesModuleCoursesNew,
  HomePageSettingsModulesModuleCoursesSelected,
  HomePageSettingsModulesModulePathsAvailable,
  HomePageSettingsModulesModulePathsSelected,
  HomePageSettingsModulesModuleQuickLinks
} from 'components/admin/settings/homepage';
import {
  HomeCalendarEventsAvailable,
  HomeCalendarEventsSelected,
  HomeCoursesAvailable,
  HomeCoursesCategory,
  HomeCoursesNew,
  HomeCoursesSelected,
  HomePathsAvailable,
  HomePathsSelected,
  HomeQuickLinks
} from 'components/homepage';

import type { ReduxRootState } from 'types';

interface Params {
  messages: ReduxRootState['messages'];
  serverConfig: ReduxRootState['serverConfig'];
}

const getHomePageModulesByType = ({ messages, serverConfig }: Params) => {
  const calendarEventsVisible = !serverConfig.hideCalendarEventsFromUI;
  const coursesVisible = !serverConfig.hideCoursesFromUI;
  const pathsVisible = !serverConfig.hidePathsFromUI;

  const modulesByType = {
    ...(coursesVisible && {
      'active-courses': {
        blurb: messages.homePageModuleActiveBlurb,
        defaultData: null,
        isSelectable: false,
        title: messages.coursesMyCourses,
        unique: true,
        HomeComponent: (props: any) => null,
        SettingsComponent: (props: any) => null
      }
    }),
    ...(pathsVisible && {
      'active-paths': {
        blurb: messages.homePageModuleActivePathsBlurb,
        defaultData: null,
        isSelectable: false,
        title: messages.pathsMyPaths,
        unique: true,
        HomeComponent: (props: any) => null,
        SettingsComponent: (props: any) => null
      }
    }),
    ...(calendarEventsVisible && {
      'calendar-events-available': {
        blurb: messages.homePageModuleCalendarEventsAvailableBlurb,
        defaultData: null,
        isSelectable: true,
        title: messages.homePageModuleCalendarEventsAvailableTitle,
        unique: true,
        HomeComponent: HomeCalendarEventsAvailable,
        SettingsComponent: HomePageSettingsModulesModuleCalendarEventsAvailable
      }
    }),
    ...(calendarEventsVisible && {
      'calendar-events-selected': {
        blurb: messages.homePageModuleCalendarEventsSelectedBlurb,
        defaultData: null,
        isSelectable: true,
        title: messages.commonSelectedCalendarEvents,
        unique: false,
        HomeComponent: HomeCalendarEventsSelected,
        SettingsComponent: HomePageSettingsModulesModuleCalendarEventsSelected
      }
    }),
    ...(coursesVisible && {
      'courses-available': {
        blurb: messages.homePageModuleCoursesAvailableBlurb,
        defaultData: null,
        isSelectable: true,
        title: messages.homePageModuleCoursesAvailableTitle,
        unique: true,
        HomeComponent: HomeCoursesAvailable,
        SettingsComponent: HomePageSettingsModulesModuleCoursesAvailable
      }
    }),
    ...(coursesVisible && {
      'courses-category': {
        blurb: messages.homePageModuleCoursesCategoryBlurb,
        defaultData: null,
        isSelectable: true,
        title: messages.homePageModuleCoursesCategoryTitle,
        unique: false,
        HomeComponent: HomeCoursesCategory,
        SettingsComponent: HomePageSettingsModulesModuleCoursesCategory
      }
    }),
    ...(coursesVisible && {
      'courses-new': {
        blurb: messages.homePageModuleCoursesNewBlurb,
        defaultData: { monthsAfterPublish: 3 },
        isSelectable: true,
        title: messages.homePageModuleCoursesNewTitle,
        unique: true,
        HomeComponent: HomeCoursesNew,
        SettingsComponent: HomePageSettingsModulesModuleCoursesNew
      }
    }),
    ...(coursesVisible && {
      'courses-selected': {
        blurb: messages.homePageModuleCoursesSelectedBlurb,
        defaultData: null,
        isSelectable: true,
        title: messages.commonSelectedCourses,
        unique: false,
        HomeComponent: HomeCoursesSelected,
        SettingsComponent: HomePageSettingsModulesModuleCoursesSelected
      }
    }),
    ...(pathsVisible && {
      'paths-available': {
        blurb: messages.homePageModulePathsAvailableBlurb,
        defaultData: null,
        isSelectable: true,
        title: messages.homePageModulePathsAvailableTitle,
        unique: true,
        HomeComponent: HomePathsAvailable,
        SettingsComponent: HomePageSettingsModulesModulePathsAvailable
      }
    }),
    ...(pathsVisible && {
      'paths-selected': {
        blurb: messages.homePageModulePathsSelectedBlurb,
        defaultData: null,
        isSelectable: true,
        title: messages.commonSelectedPaths,
        unique: false,
        HomeComponent: HomePathsSelected,
        SettingsComponent: HomePageSettingsModulesModulePathsSelected
      }
    }),
    'quick-links': {
      blurb: messages.homePageModuleQuickLinksBlurb,
      defaultData: null,
      isSelectable: false,
      title: messages.homePageModuleQuickLinksTitle,
      unique: true,
      HomeComponent: HomeQuickLinks,
      SettingsComponent: HomePageSettingsModulesModuleQuickLinks
    }
  };

  return modulesByType;
};

export default getHomePageModulesByType;
